/**
 * Copyright © 2026 Adnuntius AS.
 */
import {
  Component,
  ComponentRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {UIRouter} from '@uirouter/core';

import {getAdminResourceEditComponent} from './admin-resource-edit-route-registry';
import {AdminResourceRouteContext, readAdminResourceRouteContext} from './admin-resource-route-context';

@Component({
  standalone: false,
  selector: 'adn-admin-resource-edit-route-page',
  template: '<ng-template #host></ng-template>'
})
export class AdminResourceEditRoutePageComponent implements OnInit, OnDestroy {
  @Input() edit: string;

  @ViewChild('host', {read: ViewContainerRef, static: true}) host: ViewContainerRef;

  private componentRef: ComponentRef<any>;

  constructor(private readonly uiRouter: UIRouter) {
  }

  ngOnInit(): void {
    const editComponent = getAdminResourceEditComponent(this.edit);
    if (!editComponent) {
      return;
    }

    const context = readAdminResourceRouteContext(this.uiRouter);
    if (!context.model || !context.modelComms) {
      return;
    }

    this.componentRef = this.host.createComponent(editComponent);
    this.applyContext(context);
  }

  ngOnDestroy(): void {
    this.componentRef?.destroy();
  }

  private applyContext(context: AdminResourceRouteContext): void {
    this.componentRef.setInput('model', context.model);
    this.componentRef.setInput('modelComms', context.modelComms);
    this.componentRef.setInput('isNew', context.isNew);
  }
}
